import React from 'react';
import * as S from './style';
import { ContentsContainer, ChkBox } from 'components';
import { SERVICE_OFFER_STATUS } from 'commons/ZimssaConstant';

export interface Props {
    serviceType: string;
    category: string;
    contentsList: Array<{
        name: string;
        defaultCheck: boolean;
        notDefaultCheck: boolean;
        notServiceCheck: boolean;
        onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>, value?: any, checked?: boolean) => void;
    }>;
}

function FeatureRegister({ serviceType, category, contentsList }: Props): React.ReactElement {
    const isFamilyMove = serviceType === 'familymove';
    const optionContents = [
        { id: 0, option: <span>기본 서비스(필수사항<br/>or 견적가 포함)</span> },
        { id: 1, option: isFamilyMove ? <span>협의 필요<br/>(방문 견적 후 상담)</span> : <span>협의 필요</span> },
        { id: 2, option: <span>제공 불가<br/>서비스</span> },
    ];
    const setOptionContent = ( optionId: number ) => optionContents.find(({ id }) => id === optionId);

    return (
        <ContentsContainer required={true} title={category}>
            <S.FeatureContainer>
                <S.FeatureOptionRow>
                    <S.CenterOptionItemCell />
                    <S.CenterOptionItemCell>
                        <S.FeatureStyleLabel contents={setOptionContent(0)?.option} />
                    </S.CenterOptionItemCell>
                    <S.CenterOptionItemCell>
                        <S.FeatureStyleLabel contents={setOptionContent(1)?.option} />
                    </S.CenterOptionItemCell>
                    <S.CenterOptionItemCell>
                        <S.FeatureStyleLabel contents={setOptionContent(2)?.option} />
                    </S.CenterOptionItemCell>
                </S.FeatureOptionRow>
            </S.FeatureContainer>
            {contentsList.map((item, index) => (
                <S.FeatureContentsRow key={index}>
                    <S.ItemCell>
                        <S.FeatureStyleLabel contents={item.name} />
                    </S.ItemCell>
                    <S.FeatureContentsWrapper>
                        <S.CenterContentItemCell>
                            <ChkBox boxType={'RADIO'} value={SERVICE_OFFER_STATUS.AVAILABLE} checked={item.defaultCheck} onClick={item.onClick} />
                        </S.CenterContentItemCell>
                        <S.CenterContentItemCell>
                            <ChkBox boxType={'RADIO'} value={SERVICE_OFFER_STATUS.NEGOTIABLE} checked={item.notDefaultCheck} onClick={item.onClick} />
                        </S.CenterContentItemCell>
                        <S.CenterContentItemCell>
                            <ChkBox boxType={'RADIO'} value={SERVICE_OFFER_STATUS.NOT_AVAILABLE} checked={item.notServiceCheck} onClick={item.onClick} />
                        </S.CenterContentItemCell>
                    </S.FeatureContentsWrapper>
                </S.FeatureContentsRow>
            ))}
        </ContentsContainer>
    );
}

export default FeatureRegister;
